import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { PrmCurriculumProgressReportResult } from 'types/schema-generated-types';
import { sortCurriculum } from './lesson-progress-chart-util';
import LessonProgressBar from './LessonProgressBar';

type Props = {
  prmCurriculumProgressReport?: PrmCurriculumProgressReportResult;
};

const LessonProgressChart: React.FC<Props> = ({ prmCurriculumProgressReport }) => {
  const classes = useStyles();
  return (
    <Box className={classes.base}>
      {sortCurriculum(prmCurriculumProgressReport?.curriculums).map((x, index) => (
        <LessonProgressBar
          key={index}
          productCurriculum={x.productCurriculum}
          completed={x.averageLessonCompletedCount}
          assigned={x.averageLessonAssignedCount}
          total={x.totalLessonCount}
        />
      ))}
    </Box>
  );
};

const useStyles = makeStyles(() => ({
  base: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: 16
  }
}));

export default LessonProgressChart;
